// extracted by mini-css-extract-plugin
module.exports = {"desk":"Grid-module_desk_3pKwO","table":"Grid-module_table_3xBim","actions":"Grid-module_actions_1dn2m","dropdown":"Grid-module_dropdown_-bgMx","icon":"Grid-module_icon_3d3Rf"};